exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2020\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.fake {\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-background-h, 0), var(--ui-background-s, 0%), var(--ui-background-l, 95.68627%), 1);\n}\n\n.vis-recommender__preview-fake {\n  cursor: default;\n}\n\n.vis-recommender__preview-fake:hover,\n.vis-recommender__preview-fake:active {\n  outline: none;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/lib/@waca/vis-recommender/src/js/preview/fakeVisPreviewList.scss
// module id = 364
// module chunks = 0